import { api } from '../api'
import type { CheckClassifierCreditResult, ClassifierStatusResult } from '../types'

/**
 * Whether Jev is out of credit, and what that is holding up (BIBLE §15.6).
 *
 * The status is polled by the banner on every page, so nothing else needs to know when it
 * changes. The check is the banner's button: it probes now, and the replies it sorted
 * change the inbox, so the inbox is invalidated with it.
 */
export const classifierApi = api.injectEndpoints({
  endpoints: (build) => ({
    getClassifierStatus: build.query<ClassifierStatusResult, void>({
      query: () => '/classifier/status',
      providesTags: ['Classifier'],
    }),

    checkClassifierCredit: build.mutation<CheckClassifierCreditResult, void>({
      query: () => ({ url: '/classifier/check', method: 'POST' }),
      invalidatesTags: ['Conversation'],
    }),
  }),
})

export const { useGetClassifierStatusQuery, useCheckClassifierCreditMutation } = classifierApi
